"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Layerkatalog-Panel (extern)
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.module.GCLayerCatalog
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCLayerCatalog} options.module Modul-Instanz
 * @param {gc.gis.util.GCRequestManager} options.requestManager
 * @param {gc.gis.map.GCMapView} options.mapView
 */
gc.gis.module.GCLayerCatalog.ExternalPanel = function( options )
{
	gc.gis.widget.GCWidget.call(this, options);

	this._module = options.module;
	this._requestManager = options.requestManager;
	this._mapView = options.mapView;
	this._wms_provider = gc.gis.iface.mapFactory.createWMSProvider(this._requestManager, this._mapView.getMap());
	this._wfs_provider = gc.gis.iface.mapFactory.createWFSProvider({});
};
gc.gis.module.GCLayerCatalog.ExternalPanel.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 *
 */
gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._render = function()
{
	var init = false;

	// Item-Container
	if( !this.element )
	{
		this.element = jQuery('<div>', {
			'class': 'widget-external-catalog'
		});

		init = true;
	}
	else
	{
		this.element.children().remove();
	}

	// Content rendern
	this._initContent();

	// Ggf. an target andocken
	if( this.target && !init )
	{
		jQuery( this.target ).append( this.element );
	}

	return this.element;
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._initContent = function()
{
	// WMS
	var div_category_wms_new = this._initCategoryNewWMS();
	div_category_wms_new.hide();
	var l_category_wms_new = jQuery('<strong>', {
		html: '<span class="glyphicon"></span><span>Neuer WMS</span>',
		'class': 'gc-control-advanced-label',
		click: function( evt ) {
			div_category_wms_new.toggle('blind', {
				complete: function() {
					if( !div_category_wms_new.is(':visible') )
					{
						jQuery(this).parent().removeClass('gc-expanded').addClass('gc-collapsed');
					}
					else
					{
						jQuery(this).parent().removeClass('gc-collapsed').addClass('gc-expanded');
					}
				}
			});
		}
	});

	var li_category_wms_new = jQuery('<div>', {
		'class': 'gc-control-advanced gc-collapsed'
	});
	li_category_wms_new
		.append( l_category_wms_new )
		.append( div_category_wms_new );

	// WFS
	var div_category_wfs_new = this._initCategoryNewWFS();
	div_category_wfs_new.hide();
	var l_category_wfs_new = jQuery('<strong>', {
		html: '<span class="glyphicon"></span><span>Neuer WFS</span>',
		'class': 'gc-control-advanced-label',
		click: function( evt ) {
			div_category_wfs_new.toggle('blind', {
				complete: function() {
					if( !div_category_wfs_new.is(':visible') )
					{
						jQuery(this).parent().removeClass('gc-expanded').addClass('gc-collapsed');
					}
					else
					{
						jQuery(this).parent().removeClass('gc-collapsed').addClass('gc-expanded');
					}
				}
			});
		}
	});
	var li_category_wfs_new = jQuery('<div>', {
		'class': 'gc-control-advanced gc-collapsed'
	});
	li_category_wfs_new
		.append( l_category_wfs_new )
		.append( div_category_wfs_new );

	// Container
	//var ul_categories = jQuery('<div>', {
	//	'class': 'widget-external-categories'
	//});
	//ul_categories.append( li_category_wms_new ).append( li_category_wfs_new );
	this.element.append( li_category_wms_new ).append( li_category_wfs_new );

	//this.element.append( ul_categories );
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._initCategoryNewWMS = function()
{
	var self = this;

	var div_category_wms_new = jQuery('<div>', {
		'class': 'gc-control-advanced-content'
	});

	var form_wms_get = {
		className: 'form-wms-get-capabilities',
		controls: [
			{
				label: 'GetCapabilities-URL',
				name:  'wms_capabilities_url',
				size:  32,
				type:  'url'
			},
			{
				label: 'Laden',
				type:  'submit'
			}
		],
		validate: function( form, params ) {
			if( !params.wms_capabilities_url )
			{
				throw new gc.gis.error.GCError('GetCapabilities-URL nicht angegeben');
			}
			else if(!gc.gis.GCUrl.isUrl(params.wms_capabilities_url))
			{
				throw new gc.gis.error.GCError('Ungültige GetCapabilities-URL');
			}
		},
		reset: function( form ) {
			div_category_wms_new.find('.form-wms-setup').remove();
		},
		submit: function(form, params) {
			form.setLoading(true);
			div_category_wms_new.find('.form-wms-setup').remove();

			try
			{
				self._wms_provider.getCapabilities(params.wms_capabilities_url, cap => {
					try
					{
						div_category_wms_new.append(
							gc.gis.util.GCFormRenderer.renderForm(
								self._getWMSFormConfig(cap)
							).getElement()
						);
						form.setLoading( false );
					}
					catch(err)
					{
						gc.gis.iface.log.error( self, err );
						form.setLoading( false );
					}
				});
			}
			catch (err) {
				gc.gis.iface.log.error(self, err);
				form.setLoading(false);
			}
		},
		error: function( form, err ) {
			form.setLoading( false );
		}
	};

	div_category_wms_new
		.append( gc.gis.util.GCFormRenderer.renderForm( form_wms_get ).getElement() );


	return div_category_wms_new;
};

gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._getSelectOptionsFromLayersCapabilities = function(capLayerList, layerHierarchyLevel)
{
	let options = [];
	layerHierarchyLevel = layerHierarchyLevel || 0;

	for (let i = 0, ii = capLayerList.length; i < ii; i++)
	{
		const capLayer = capLayerList[i];
		const numStyles = capLayer.styles.length;

		if (capLayer.name)
		{
			options.push(this._getSelectOptionForNamedLayer(capLayer, layerHierarchyLevel));
		}
		else
		{
			options.push(this._getSelectOptionForUnnamedLayer(capLayer, layerHierarchyLevel));
		}

		if (capLayer.name && numStyles > 1)
		{
			for (let j = 0; j < numStyles; j++)
			{
				options.push(this._getSelectOptionForNamedLayerStyle(j, capLayer, layerHierarchyLevel))
			}
		}

		if (capLayer.layers)
		{
			options = options.concat(this._getSelectOptionsFromLayersCapabilities(capLayer.layers, layerHierarchyLevel + 1));
		}
	}

	return options;
};

gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._getSelectOptionForNamedLayer = function(namedLayer, layerHierarchyLevel)
{
	return {
		label: namedLayer.label,
		tooltip: namedLayer.label + ' (' + namedLayer.name  + ')',
		className: 'level' + layerHierarchyLevel + (namedLayer.layers ? ' has-sub-layers' : ''),
		data: {
			name: namedLayer.name,
			style: ''
		}
	};
};

gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._getSelectOptionForNamedLayerStyle = function(styleIndex, namedLayer, layerHierarchyLevel)
{
	const option = this._getSelectOptionForNamedLayer(namedLayer, layerHierarchyLevel);
	option.label = namedLayer.styles[styleIndex].label;
	option.tooltip += ' [' + namedLayer.styles[styleIndex].label + ']'
	option.data.style = namedLayer.styles[styleIndex].name;
	option.className = 'level' + layerHierarchyLevel + ' is-style';

	return option;
};

gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._getSelectOptionForUnnamedLayer = function(unnamedLayer, layerHierarchyLevel)
{
	return {
		label: unnamedLayer.label,
		tooltip: unnamedLayer.label,
		className: 'level' + layerHierarchyLevel + (unnamedLayer.layers ? ' has-sub-layers' : ''),
		disabled: true
	};
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._getWMSFormConfig = function(capabilities)
{
	const self = this;
	const layersOptions = this._getSelectOptionsFromLayersCapabilities(capabilities.layers)
	let layerSelector;

	const form_wms_load = {
		className: 'form-wms-setup',
		controls: [
			{
				label:         'WMS-Name',
				name:          'wms_title',
				type:          'static',
				value:         capabilities.title,
				display_value: '<strong>'+ capabilities.title +'</strong>'
			},
			{
				label:    'Verfügbare Ebenen',
				name:     'wms_layers',
				type:     'select',
				multiple: true,
				options:  layersOptions,
				size:     Math.min(Math.max(5, layersOptions.length), 15),
				initFunc: function(control) {
					layerSelector = control;
				}
			},
			{
				type:     'advanced',
				label:    'Erweitert',
				controls: [
					{
						label:   'Format',
						name:    'wms_format',
						type:    'select',
						options: capabilities.formats,
						default: 'image/png'
					},
					{
						label:   'Kacheln',
						name:    'wms_tiled',
						type:    'radio',
						options: [
							{
								label: 'Ja',
								value: true
							},
							{
								label:   'Nein',
								value:   false,
								default: true
							}
						]
					}
				]
			},
			{
				label: 'WMS-Ebene hinzufügen',
				type:  'submit'
			}
		],
		validate: function( form, params ) {
			if( !params.wms_layers || !params.wms_layers.length )
			{
				throw new gc.gis.error.GCError('Keine Ebenen ausgewählt');
			}
		},
		submit: function(form, params) {
			form.setLoading(true);

			const layerSelection = layerSelector.getWidget().getDataForSelection();
			const layerList = [];
			const styleList = [];
			for (let i = 0, ii = layerSelection.length; i < ii; i++)
			{
				layerList.push(layerSelection[i].name);
				styleList.push(layerSelection[i].style || '');
			}

			const layerConfig = self._wms_provider.getLayerConfig(capabilities, layerList, styleList, {
				format:  params.wms_format,
				tiled:   params.wms_tiled,
				preferredCRS: self._mapView.getProjection()
			});
			self._mapView.loadLayer(layerConfig)

			gc.gis.iface.ui.sidebar.historyBack();
			form.setLoading(false);
		},
		error: function(form, err) {
			form.setLoading(false);
		}
	};

	return form_wms_load;
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._initCategoryNewWFS = function()
{
	var self = this;

	var div_category_wfs_new = jQuery('<div>', {
		'class': 'gc-control-advanced-content'
	});

	var form_wfs_get = {
		className: 'form-wms-get-capabilities',
		controls: [
			{
				label: 'GetCapabilities-URL',
				name:  'wfs_url',
				type:  'url'
			},
			{
				label:   'Version',
				name:    'wfs_version',
				type:    'select',
				options: [
					{
						label: '1.1.0',
						value: '1.1.0',
						default: true
					},
					{
						label: '1.0.0',
						value: '1.0.0'
					}
				]
			},
			{
				label:   'Ebenen',
				name:    'wfs_layers',
				type:    'text'
			},
			{
				label: 'WFS-Ebene hinzufügen',
				type:  'submit'
			}
		],
		validate: function( form, params ) {
			if( !params.wfs_url )
			{
				throw new gc.gis.error.GCError('GetCapabilities-URL nicht angegeben');
			}
			else if(!gc.gis.GCUrl.isUrl(params.wfs_url))
			{
				throw new gc.gis.error.GCError('Ungültige GetCapabilities-URL');
			}

			if( !params.wfs_layers )
			{
				throw new gc.gis.error.GCError('Ebene(n) nicht angegeben');
			}
		},
		submit: function( form, params ) {
			form.setLoading( true );
			// FIXME: wait for implementation of ol.format.WFSCapabilities
			// https://github.com/openlayers/openlayers/issues/5610 => das sieht nicht gut aus
			// https://github.com/highsource/ogc-schemas
			var capabilities = undefined;
			var wfs_config = self._getWFSLayerConfig( capabilities, params );
			self._wfs_provider.loadWFS( wfs_config );
			self.module.map.updateMap();
			gc.gis.iface.ui.sidebar.historyBack();
			form.setLoading( false );
		},
		error: function( form, err ) {
			form.setLoading( false );
		}
	};

	div_category_wfs_new
		.append( gc.gis.util.GCFormRenderer.renderForm( form_wfs_get ).getElement() );

	return div_category_wfs_new;
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.ExternalPanel.prototype._getWFSLayerConfig = function( capabilities, params )
{
	gc.gis.assert.isSet( params );
	gc.gis.assert.isSet( params.wfs_layers );
	gc.gis.assert.isSet( params.wfs_version );
	gc.gis.assert.isSet( params.wfs_url );

	var layer_name = params.wfs_layers;
	var layer_attribution = 'Nicht implementiert für WFS';

	var config = {
		isInternal:   false,
		type:         'wfs',
		originalType: 'external_wfs',
		// name:         layer_name,
		name:         params.wfs_layers,
		label:        layer_name,
		attribution:  layer_attribution,
		availableVersions:      [params.wfs_version],
		version:      params.wfs_version,
		baseUrl:      params.wfs_url,
		layer:        params.wfs_layers
	};

	return config;
};
